// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"dc589441","245":"6c5f580b","276":"0fd4e8af","620":"14bdb65b","782":"3e9d3c0b"}[chunkId] + ".chunk.css";
};